import { render, staticRenderFns } from "./Procedings.vue?vue&type=template&id=74389de8&"
import script from "./Procedings.vue?vue&type=script&lang=js&"
export * from "./Procedings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports